export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  ARCHIVED = 'ROLE_ARCHIVED',
  COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN',
  COMPANY_SUPER_ADMIN = 'ROLE_COMPANY_SUPER_ADMIN',
  COMPANY_USER = 'ROLE_COMPANY_USER',
  CMS_SUPER_ADMIN = 'ROLE_CMS_SUPER_ADMIN',
  CMS_ADMIN = 'ROLE_CMS_ADMIN',
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  NIO_ADMIN = 'ROLE_NIO_ADMIN',
  NIO_SUPER_ADMIN = 'ROLE_NIO_SUPER_ADMIN',
  COMPANY_ORG_ADMIN = 'ROLE_COMPANY_ORGANIZATION_ADMIN',
  NIO_ORG_ADMIN = 'ROLE_NIO_ORGANIZATION_ADMIN',
  NIO_USER = 'ROLE_NIO_USER',
  COMPANY_SUPER = 'COMPANY_SUPER_ADMIN',
}
